import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full min-h-0" }
const _hoisted_2 = { class: "flex-1 min-h-0 flex flex-col" }
const _hoisted_3 = { class: "flex-1 flex flex-col mt-4 overflow-y-auto" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_5 = { class: "flex flex-row gap-2 max-w-max whitespace-nowrap w-3/5" }
const _hoisted_6 = { class: "w-full p-4" }
const _hoisted_7 = { class: "w-full flex justify-between items-center" }
const _hoisted_8 = { class: "w-1.5/5 flex gap-10 items-center" }
const _hoisted_9 = { class: "w-1.5/5 flex gap-3 items-center" }
const _hoisted_10 = { class: "flex gap-1" }
const _hoisted_11 = { class: "flex flex-col gap-1" }
const _hoisted_12 = { class: "w-2/5 flex items-center justify-end gap-4" }
const _hoisted_13 = { class: "w-1/2 flex flex-col gap-2" }
const _hoisted_14 = { class: "flex justify-between items-center" }
const _hoisted_15 = { class: "flex gap-2 items-center" }
const _hoisted_16 = { class: "flex gap-2 items-center" }
const _hoisted_17 = { class: "flex justify-between items-center" }
const _hoisted_18 = { class: "flex gap-2 items-center" }
const _hoisted_19 = { class: "flex gap-2 items-center" }
const _hoisted_20 = { class: "flex item-center gap-4" }
const _hoisted_21 = {
  key: 1,
  class: "flex flex-col items-center justify-center",
  style: {"height":"100vh"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CargoV2FilterRtc = _resolveComponent("CargoV2FilterRtc")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_CargoV2CardRtc = _resolveComponent("CargoV2CardRtc")!
  const _component_ButtonLoadMore = _resolveComponent("ButtonLoadMore")!
  const _component_ModalBookingTruck = _resolveComponent("ModalBookingTruck")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_CargoV2FilterRtc, {
        isPlane: false,
        onFilter: _ctx.onFilter,
        transportType: "truck"
      }, null, 8, ["onFilter"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (i) => {
                  return _createVNode("div", {
                    key: i,
                    class: "w-full bg-white border rounded-lg border-gray-lp-1400 mb-4"
                  }, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode(_component_Skeleton, {
                        width: "8rem",
                        height: "1.5rem",
                        class: "rounded-tl-lg"
                      }),
                      _createVNode(_component_Skeleton, {
                        width: "10rem",
                        height: "1.5rem",
                        class: "rounded-br-lg"
                      })
                    ]),
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("div", _hoisted_8, [
                          _createVNode("div", null, [
                            _createVNode(_component_Skeleton, {
                              width: "3rem",
                              height: "1.5rem",
                              class: "mb-1"
                            }),
                            _createVNode(_component_Skeleton, {
                              width: "5rem",
                              height: "0.8rem"
                            })
                          ]),
                          _createVNode(_component_Skeleton, {
                            width: "4.5rem",
                            height: "2.75rem"
                          }),
                          _createVNode("div", null, [
                            _createVNode(_component_Skeleton, {
                              width: "3rem",
                              height: "1.5rem",
                              class: "mb-1"
                            }),
                            _createVNode(_component_Skeleton, {
                              width: "5rem",
                              height: "0.8rem"
                            })
                          ])
                        ]),
                        _createVNode("div", _hoisted_9, [
                          _createVNode("div", _hoisted_10, [
                            _createVNode(_component_Skeleton, {
                              width: "2rem",
                              height: "1.2rem"
                            }),
                            _createVNode(_component_Skeleton, {
                              width: "2rem",
                              height: "1.2rem"
                            })
                          ]),
                          _createVNode("div", _hoisted_11, [
                            _createVNode(_component_Skeleton, {
                              width: "6rem",
                              height: "0.8rem"
                            }),
                            _createVNode(_component_Skeleton, {
                              width: "8rem",
                              height: "1rem"
                            })
                          ])
                        ]),
                        _createVNode("div", _hoisted_12, [
                          _createVNode("div", _hoisted_13, [
                            _createVNode("div", _hoisted_14, [
                              _createVNode("div", _hoisted_15, [
                                _createVNode(_component_Skeleton, {
                                  width: "1rem",
                                  height: "1rem"
                                }),
                                _createVNode(_component_Skeleton, {
                                  width: "4rem",
                                  height: "0.8rem"
                                })
                              ]),
                              _createVNode("div", _hoisted_16, [
                                _createVNode(_component_Skeleton, {
                                  width: "2rem",
                                  height: "1rem"
                                }),
                                _createVNode(_component_Skeleton, {
                                  width: "1rem",
                                  height: "1rem"
                                })
                              ])
                            ]),
                            _createVNode("div", _hoisted_17, [
                              _createVNode("div", _hoisted_18, [
                                _createVNode(_component_Skeleton, {
                                  width: "1rem",
                                  height: "1rem"
                                }),
                                _createVNode(_component_Skeleton, {
                                  width: "4rem",
                                  height: "0.8rem"
                                })
                              ]),
                              _createVNode("div", _hoisted_19, [
                                _createVNode(_component_Skeleton, {
                                  width: "2rem",
                                  height: "1rem"
                                }),
                                _createVNode(_component_Skeleton, {
                                  width: "1rem",
                                  height: "1rem"
                                })
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_20, [
                            _createVNode(_component_Skeleton, {
                              width: "3.5rem",
                              height: "3.5rem"
                            }),
                            _createVNode(_component_Skeleton, {
                              width: "8rem",
                              height: "3.5rem"
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                }), 64))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.rtcList.data.length && !_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                (!_ctx.hasActiveFilter)
                  ? (_openBlock(), _createBlock(_component_EmptyState, {
                      key: 0,
                      data: _ctx.$t('cargoV2.create.rtcList.emptyTitle')
                    }, null, 8, ["data"]))
                  : (_openBlock(), _createBlock(_component_ErrorMessage, {
                      key: 1,
                      class: "mt-4",
                      "error-message": _ctx.errorContainer.errorMessage,
                      "error-title": _ctx.errorContainer.errorTitle,
                      "error-image": _ctx.errorContainer.errorIcon
                    }, null, 8, ["error-message", "error-title", "error-image"]))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLoading)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.rtcListData, (item) => {
                return (_openBlock(), _createBlock(_component_CargoV2CardRtc, {
                  key: item.id,
                  data: item,
                  isBossPack: item.isBosspack,
                  isDg: item.isDangerousGoods,
                  isK: item.isQuarantine,
                  onOpenModal: _ctx.onProcess,
                  onEdit: _ctx.onEdit
                }, null, 8, ["data", "isBossPack", "isDg", "isK", "onOpenModal", "onEdit"]))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.rtcList.data.length && !_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_ButtonLoadMore, {
                key: 3,
                dataLength: _ctx.rtcList.data.length,
                limit: _ctx.rtcListLimit,
                "onUpdate:limit": _cache[1] || (_cache[1] = ($event: any) => (_ctx.rtcListLimit = $event))
              }, null, 8, ["dataLength", "limit"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_ModalBookingTruck, {
      modelValue: _ctx.showModalForm,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalForm = $event)),
      moda: "truck",
      onRefresh: _ctx.onRefresh,
      onCloseCheckEligible: _ctx.onCloseCheckEligible
    }, null, 8, ["modelValue", "onRefresh", "onCloseCheckEligible"])
  ], 64))
}